import { TheaterType as ITheaterType } from "@multicines/types";
import React, { useCallback, useMemo } from "react";

import Styles from "./TheaterTypeList.styles";
import { TheaterTypeListProps as Props } from "./TheaterTypeList.types";
import TheaterType from "../TheaterType/TheaterType";

const TheaterTypeList: React.FC<Props> = props => {
  const { className, theaters, disabled, name, isPremiere } = props;
  const { onClick } = props;

  const renderItem = useCallback(
    (listItem: ITheaterType, index: number) => {
      const theaterType = listItem;
      return (
        <TheaterType
          key={index}
          className="TheaterTypeList__theater"
          theaterType={theaterType}
          disabled={disabled}
          name={name}
          isPremiere={isPremiere}
          onClick={onClick}
        />
      );
    },
    [disabled, isPremiere, name, onClick]
  );

  const renderItemMemoized = useMemo(() => renderItem, [renderItem]);

  return (
    <Styles className={`TheaterTypeList ${className}`}>
      {theaters.map((item, index) => {
        return renderItemMemoized(item, index);
      })}
    </Styles>
  );
};

export default TheaterTypeList;
